var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layouts_oridnary",attrs:{"id":"ordinary"}},[_c('HeaderOrdinary'),_c('div',{staticClass:"ordinary_body"},[_c('div',{staticClass:"body_menu"},[_c('Menu')],1),_c('div',{staticClass:"body_right"},[_c('Breadcrumb'),_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }